import { render, staticRenderFns } from "./popupBase.vue?vue&type=template&id=67d36300&scoped=true&"
import script from "./popupBase.vue?vue&type=script&lang=js&"
export * from "./popupBase.vue?vue&type=script&lang=js&"
import style0 from "./popupBase.vue?vue&type=style&index=0&id=67d36300&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d36300",
  null
  
)

export default component.exports